import { getDateTimeFormatter } from '@fe/core';
import { GDFTapsRecord, GDFTapsType } from '../../../gdf/type';

export default function TapsTooltip({ record }: { record: GDFTapsRecord }) {
    const formatter = getDateTimeFormatter();
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '0.5rem' }}>
            <div>Reported:</div>
            <div>{formatter.formatTime(record.reportTime, 'hm')}</div>

            {record.private && (
                <>
                    {/* Not sure why but fe-client assumes there's only one private record in the struct despite it being an */}
                    <div>Callsign:</div>
                    <div>{record.private.acid || '-'}</div>

                    <div>Tail:</div>
                    <div>{record.private.tail || '-'}</div>
                </>
            )}

            <div>Aircraft type:</div>
            <div>{record.acType || '-'}</div>

            <div>Altitude:</div>
            {/* TODO: private data */}
            <div>{record.altitude !== null ? <span>{(record.altitude * 100).toLocaleString('en-US')} ft</span> : <span>-</span>}</div>
            {record.turbType !== GDFTapsType.heartbeat && (
                <>
                    <div>Turbulence:</div>
                    <div>{turbulenceToString(record)}</div>

                    <div>RMS/G:</div>
                    <div>{record.hazardMetric !== null ? <span>{(record.hazardMetric / 10000).toFixed(4)} g</span> : <span>-</span>}</div>

                    <div>EDR:</div>
                    <div>{record.edr !== null ? <span>{(record.edr / 10000).toFixed(4)} g</span> : <span>-</span>}</div>

                    <div>RMS load:</div>
                    <div>{record.rmsLoad !== null ? <span>{(record.rmsLoad / 10000).toFixed(4)} g</span> : <span>-</span>}</div>
                </>
            )}
            <div>Wind speed:</div>
            <div>{record.windSpeed !== null ? <span>{record.windSpeed} kt</span> : <span>-</span>}</div>

            <div>Wind dir:</div>
            <div>{record.windDir !== null ? <span>{record.windDir}°</span> : <span>-</span>}</div>

            <div>Temperature:</div>
            <div>{record.temp !== null ? <span>{record.temp} °C</span> : <span>-</span>}</div>
        </div>
    );
}

function turbulenceToString(record: GDFTapsRecord): string {
    const hazardMetric = record.hazardMetric;
    if (hazardMetric === null) {
        return '-';
    }
    if (hazardMetric < 750) return 'Smooth';
    else if (hazardMetric < 1000) return 'Ride Quality';
    else if (hazardMetric < 2000) return 'Light';
    else if (hazardMetric < 3000) return 'Moderate';
    else return 'Severe';
}
